import React, { memo } from 'react'
import { Path } from 'react-native-svg'

import { IconBase } from '../IconBase'
import { IconProps } from '../IconProps'
import { themed } from '../themed'

const Icon = (props) => {
  const { color = 'black', size = 24, ...otherProps } = props
  return (
    <IconBase
      width={size}
      height={size}
      viewBox="0 0 28 28"
      fill="none"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
      {...otherProps}
    >
      <Path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M14 2.1875C11.6637 2.1875 9.37989 2.88029 7.43733 4.17827C5.49478 5.47624 3.98074 7.3211 3.08668 9.47955C2.19262 11.638 1.95869 14.0131 2.41448 16.3045C2.87027 18.5959 3.9953 20.7007 5.64731 22.3527C7.29931 24.0047 9.4041 25.1297 11.6955 25.5855C13.9869 26.0413 16.362 25.8074 18.5205 24.9133C20.6789 24.0193 22.5238 22.5052 23.8217 20.5627C25.1197 18.6201 25.8125 16.3363 25.8125 14C25.809 10.8682 24.5634 7.86566 22.3489 5.65114C20.1343 3.43662 17.1318 2.19097 14 2.1875ZM10.0625 10.0625C9.59838 10.0625 9.15326 10.2469 8.82507 10.5751C8.49688 10.9033 8.31251 11.3484 8.31251 11.8125C8.31251 12.2766 8.49688 12.7217 8.82507 13.0499C9.15326 13.3781 9.59838 13.5625 10.0625 13.5625C10.5266 13.5625 10.9717 13.3781 11.2999 13.0499C11.6281 12.7217 11.8125 12.2766 11.8125 11.8125C11.8125 11.3484 11.6281 10.9033 11.2999 10.5751C10.9717 10.2469 10.5266 10.0625 10.0625 10.0625ZM17.9375 10.0625C17.4734 10.0625 17.0283 10.2469 16.7001 10.5751C16.3719 10.9033 16.1875 11.3484 16.1875 11.8125C16.1875 12.2766 16.3719 12.7217 16.7001 13.0499C17.0283 13.3781 17.4734 13.5625 17.9375 13.5625C18.4016 13.5625 18.8468 13.3781 19.1749 13.0499C19.5031 12.7217 19.6875 12.2766 19.6875 11.8125C19.6875 11.3484 19.5031 10.9033 19.1749 10.5751C18.8468 10.2469 18.4016 10.0625 17.9375 10.0625ZM8.31251 17.5C8.31251 17.1519 8.45079 16.8181 8.69693 16.5719C8.94307 16.3258 9.27691 16.1875 9.625 16.1875H18.375C18.7231 16.1875 19.0569 16.3258 19.3031 16.5719C19.5492 16.8181 19.6875 17.1519 19.6875 17.5C19.6875 17.8481 19.5492 18.1819 19.3031 18.4281C19.0569 18.6742 18.7231 18.8125 18.375 18.8125H9.625C9.27691 18.8125 8.94307 18.6742 8.69693 18.4281C8.45079 18.1819 8.31251 17.8481 8.31251 17.5Z"
        fill={`${color}`}
      />
    </IconBase>
  )
}

Icon.displayName = 'IconFaceNeutralFilled'

export const IconFaceNeutralFilled = memo(themed(Icon))
